import freeShipping from './free-shipping.svg';
import manageOrder from './manage-order.svg';
import moneyBack from './money-back.svg';

export const benefits = [
  {
    icon: manageOrder,
    text: 'Edit, Pause or Cancel anytime',
  },
  {
    icon: freeShipping,
    text: 'Free Shipping',
  },
  {
    icon: moneyBack,
    text: '100% Money-back Guarantee',
  },
];
